// alertActions.js

export const SHOW_ALERT = "SHOW_ALERT";
export const HIDE_ALERT = "HIDE_ALERT";
export const CLEAR_CONFIRMATION_ALERTS = "CLEAR_ALL_ALERTS"; // Add this

export const showAlert = ({
    message,
    type = "success",
    title = "",
    onConfirm = null,
    onCancel = null,
}) => ({
    type: SHOW_ALERT,
    payload: { id: Date.now(), message, type, title, onConfirm, onCancel },
});

export const hideAlert = (id) => ({
    type: HIDE_ALERT,
    payload: id,
});

export const clearConfirmationAlerts = () => ({ // Add this
    type: CLEAR_CONFIRMATION_ALERTS,
});